import styled from 'styled-components';
import {} from '@material-ui/core';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
`;

export const BackToLogin = styled.p`
  cursor: pointer;

  color: #3f51b5 !important;
  text-transform: uppercase;
  text-align: center;

  font-size: 1.3rem;

  width: fit-content !important;
  margin: 5rem auto 0 !important;

  &:hover {
    text-decoration: underline;
  }
`;
